import { library } from "@fortawesome/fontawesome-svg-core";
import { 
  faInfo, 
  faCalendarAlt, 
  faLink, 
  faUser,
  faBriefcase,
  faClock,
  faLocationDot,
  faArrowLeft,
  faMicrophone,
  faMap,
  faCheckCircle, 
  faCreditCard, 
  faBuilding, 
  faInfoCircle,
  faLock,
  faMoneyBill,
  faTimes,
  faFileInvoice,
  faPlus,
  faMinus,
  faTicket,
  faUserPlus,
  faExclamationCircle,
  faTrash,
  faFileAlt,
  faSpinner,
  faTrashAlt,
  faRedo,
  faEye,
  faCircleDown,
  faDesktop,
  faFileVideo,
  faFileAudio,
  faFilePdf,
  faFileArchive,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faFileCsv,
  faFileCode
} from "@fortawesome/free-solid-svg-icons";

// Import von Marken-Icons
import { 
  faPaypal
} from "@fortawesome/free-brands-svg-icons";

const iconMap = {
  info: faInfo,
  calendarAlt: faCalendarAlt,
  link: faLink,
  user: faUser,
  briefcase: faBriefcase,
  clock: faClock,
  locationDot: faLocationDot,
  arrowLeft: faArrowLeft,
  microphone: faMicrophone,
  map: faMap,
  fileInvoice: faFileInvoice,
  // Checkout-Icons
  checkCircle: faCheckCircle,
  creditCard: faCreditCard,
  paypal: faPaypal,
  building: faBuilding,
  infoCircle: faInfoCircle,
  lock: faLock,
  moneyBill: faMoneyBill,
  times: faTimes,
  plus: faPlus,
  minus: faMinus,
  ticket: faTicket,
  userPlus: faUserPlus,
  exclamationCircle: faExclamationCircle,
  trash: faTrash,
  // FileDropzone Icons
  fileAlt: faFileAlt,
  "file-alt": faFileAlt,
  spinner: faSpinner,
  trashAlt: faTrashAlt,
  "trash-alt": faTrashAlt,
  redo: faRedo,
  eye: faEye,
  "check-circle": faCheckCircle,
  "exclamation-circle": faExclamationCircle,
  circleDown: faCircleDown,
  "circle-down": faCircleDown,
  desktop: faDesktop,
  // File type icons
  fileVideo: faFileVideo,
  "file-video": faFileVideo,
  fileAudio: faFileAudio,
  "file-audio": faFileAudio,
  filePdf: faFilePdf,
  "file-pdf": faFilePdf,
  fileArchive: faFileArchive,
  "file-archive": faFileArchive,
  fileWord: faFileWord,
  "file-word": faFileWord,
  fileExcel: faFileExcel,
  "file-excel": faFileExcel,
  filePowerpoint: faFilePowerpoint,
  "file-powerpoint": faFilePowerpoint,
  fileCsv: faFileCsv,
  "file-csv": faFileCsv,
  fileCode: faFileCode,
  "file-code": faFileCode
};

export async function loadIcon(iconName, iconType = "solid") {
	try {
		const icon = iconMap[iconName];
		if (!icon) {
			throw new Error(`Icon "${iconName}" not found`);
		}
		library.add(icon);
		return icon;
	} catch (error) {
		console.error(`Could not load icon "${iconName}": ${error.message}`);
		throw error;
	}
}
